import React, { Component } from 'react';
import HelloContainer from './hello.container';
import AboutContainer from './about.container';
import SpiceContainer from './spice.container';
import SkillContainer from './skill.container';
import PastProjectContainer from './pastProject.container';
import ExperienceContainer from './experience.container';
import QualificationContainer from './qualification.container';
import ContactContainer from './contact.container';
const data = require('../data.json')
class App extends Component {  
  render() {
    return (
      <div>
        <HelloContainer />
        <AboutContainer />
        <SpiceContainer className="spice spice-primary" title="I enjoy turning concepts into reality."/>
        <SkillContainer data={data.skills}/>
        <PastProjectContainer data={data.projects}/>
        <SpiceContainer className="spice spice-big spice-secondary" title='"Stay hungry. Stay foolish."' description="That's my favorite quote from Steve Jobs. I'm always trying to update my knowledge."/>
        <ExperienceContainer data={data.experience}/>
        <QualificationContainer data={data.qualification}/>
        <SpiceContainer />
        <ContactContainer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.jsx